import { render, staticRenderFns } from "./DesignatedUser.vue?vue&type=template&id=9f86d7cc&scoped=true"
import script from "./DesignatedUser.vue?vue&type=script&lang=js"
export * from "./DesignatedUser.vue?vue&type=script&lang=js"
import style0 from "./DesignatedUser.vue?vue&type=style&index=0&id=9f86d7cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f86d7cc",
  null
  
)

export default component.exports